import customEnv from "./envCustom.json";

type envConfType = {
  SERVER_URL: string;
  SOCKET_URL: string;
  IS_DEV: boolean;
  SECRET_KEY: string;
};

const SERVER_URL =
  customEnv.SERVER_URL || process.env.REACT_APP_SERVER_URL || "";

const SOCKET_URL =
  customEnv.SOCKET_URL || process.env.REACT_APP_SOCKET_URL || "";

const IS_DEV =
  (customEnv.IS_DEV || process.env.REACT_APP_IS_DEV)?.toUpperCase() === "TRUE"
    ? true
    : false;

const SECRET_KEY =
  customEnv.SECRET_KEY || process.env.REACT_APP_SECRET_KEY || "";

export const envconf: envConfType = {
  SERVER_URL,
  SOCKET_URL,
  IS_DEV,
  SECRET_KEY,
};

export default envconf;
